import Vue from 'vue'
import App from './App.vue'
import VModal from 'vue-js-modal'
import ToggleButton from 'vue-js-toggle-button'
import VueNumeric from 'vue-numeric'
import Buefy from 'buefy'
import VeeValidate from 'vee-validate'
import Money from 'v-money'

import router from './router'
import store from './store'
import parseData from './plugins/parseData'
import './filters'

import AWSAppSyncClient from "aws-appsync"
import VueApollo from 'vue-apollo'

import HighchartsVue from 'highcharts-vue'
import VueCompositionAPI from '@vue/composition-api'

import './registerServiceWorker'
import './stylus/index.styl'
import './assets/scss/main.scss'


const client = new AWSAppSyncClient({
  url: "https://dvvtutw7xjgadk7hnfpysk25xe.appsync-api.us-west-2.amazonaws.com/graphql",
  region: "us-east-1",
  auth: {
    type: "API_KEY",
    apiKey: "da2-hu5iacpmf5awjbbpujs4dvofai",
  }
},{
  // defaultOptions: {
  //   watchQuery: {
  //     fetchPolicy: 'cache-and-network',
  //   }
  // }
})

const appsyncProvider = new VueApollo({
  defaultClient: client
})

Vue.config.productionTip = false

Vue.use(Money, {precision: 2})
Vue.use(VModal, {dynamic: true, injectModalsContainer: true})
Vue.use(ToggleButton)
Vue.use(VueNumeric)
Vue.use(Buefy, { defaultIconPack: 'mdi'})
Vue.use(VeeValidate)
Vue.use(parseData)
Vue.use(HighchartsVue,  {tagName: 'charts'})
Vue.use(VueApollo)
Vue.use(VueCompositionAPI)

new Vue({
  router,
  store,
  apolloProvider: appsyncProvider,
  render: h => h(App)
}).$mount('#app')
